import * as React from 'react'

import { Box, SortDirection, Table } from '@factorialco/deprecated-design-system'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import i18n from 'modules/core/lib/i18n'

interface HeaderProps {
  onSort: (attribute: string, direction: SortDirection) => void
  attribute: string
  direction: SortDirection
}

const toolTip = (): React.ReactNode => {
  return (
    <Box flexDirection="row" gap="s4" alignItems="center">
      <InformationTooltip
        information={i18n.t(
          'documents.document_templates.all_available_variables_list.legal_entity_tooltip'
        )}
        icon="question"
      />
    </Box>
  )
}

interface TitleProps {
  name: string
  colSpan: number
  attribute: string
  toolTip: boolean
}

const Header = ({ onSort, direction, attribute }: HeaderProps) => {
  const titles: TitleProps[] = [
    {
      name: i18n.t('documents.document_templates.all_available_variables_list.name'),
      colSpan: 3,
      attribute: 'name',
      toolTip: false,
    },
    {
      name: i18n.t('documents.document_templates.all_available_variables_list.section'),
      colSpan: 2,
      attribute: 'section',
      toolTip: false,
    },
    {
      name: i18n.t('documents.document_templates.all_available_variables_list.legal_entity'),
      colSpan: 2,
      attribute: 'legal_entities',
      toolTip: true,
    },
  ]

  titles.push({
    name: i18n.t('documents.document_templates.all_available_variables_list.permission'),
    colSpan: 2,
    attribute: 'access',
    toolTip: false,
  })

  titles.push({
    name: i18n.t('documents.document_templates.all_available_variables_list.variable'),
    colSpan: 2,
    attribute: 'variable',
    toolTip: false,
  })

  return (
    <Table.Head>
      <Table.Row>
        {titles.map((title) => (
          <Table.SortableHeadCell
            colSpan={title.colSpan}
            key={title.name}
            attribute={title.attribute}
            onSort={onSort}
            sortAttribute={attribute}
            sortDirection={direction}
            left={title.toolTip && toolTip()}
          >
            {title.name}
          </Table.SortableHeadCell>
        ))}
        <Table.HeadCell colSpan={1} />
      </Table.Row>
    </Table.Head>
  )
}

export default Header
